export const degrees = [
  {
    id: 1,
    description: "MD",
    sort: 1,
  },
  {
    id: 2,
    description: "PhD",
    sort: 2,
  },
  {
    id: 3,
    description: "MS",
    sort: 3,
  },
  {
    id: 4,
    description: "MBA",
    sort: 4,
  },
  {
    id: 5,
    description: "TS(ABB)",
    sort: 5,
  },
  {
    id: 6,
    description: "NP",
    sort: 6,
  },
  {
    id: 7,
    description: "DO",
    sort: 7,
  },
  {
    id: 8,
    description: "MBBS",
    sort: 8,
  },
  {
    id: 9,
    description: "BMBS",
    sort: 9,
  },
  {
    id: 10,
    description: "MBChB",
    sort: 10,
  },
  {
    id: 11,
    description: "MBBCh",
    sort: 11,
  },
  {
    id: 12,
    description: "JD",
    sort: 12,
  },
  {
    id: 13,
    description: "Esq",
    sort: 13,
  },
  {
    id: 14,
    description: "FACOG",
    sort: 14,
  },
  {
    id: 15,
    description: "LCSW",
    sort: 16,
  },
  {
    id: 16,
    description: "BA",
    sort: 17,
  },
  {
    id: 17,
    description: "MSCE",
    sort: 18,
  },
  {
    id: 18,
    description: "ND",
    sort: 19,
  },
  {
    id: 19,
    description: "MA",
    sort: 20,
  },
];
